import moment from "moment";
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import CustomDataTable from "../../Components/CustomDataTable";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { Button } from "reactstrap";
import { delay } from "../../Helper/ToastDelay";

const PaymentHistory = () => {
  const columnDefs = [
    {
      field: "fld_invoiceno",
      header: "Invoice Id",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_paymentmode",
      header: "Payment Mode",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },

    {
      field: "fld_amount",
      header: "Received Amount",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_createdAt",
      header: "Added on",
      sortable: true,
      body: (rowData) =>
        moment(rowData?.fld_createdAt).format("DD MMM YYYY") || "",
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_paymentstatus",
      header: "Payment Status",
      sortable: true,
      width: "100px",
      body: (rowData) => (
        <span
          className={`${genareteColor(
            rowData.fld_paymentstatus
          )} font-size-3 rounded-3 px-2`}
        >
          {rowData.fld_paymentstatus}
        </span>
      ),
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "action",
      header: "Action",
      sortable: true,
      width: "100px",
      body: (rowData) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            window.open(
              process.env.REACT_APP_FILE_PATH_URL + rowData.fld_evidence,
              "_blank"
            );
          }}
        >
          <span style={{ fontSize: "13px", color: PRIMARY_COLOR }}>
            Evidence
          </span>
        </div>
      ),
      headerStyle: { width: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
  ];
  const user = useSelector((state) => state.login);
  const [paymentHistory, setPaymentHistory] = useState([]);
  useEffect(() => {
    (async () => {
      Notiflix.Loading.standard();
      try {
        const res = await PostApiCall.postRequest(
          { usertype: user?.fld_usertype },
          "GetAuditTransaction"
        );
        const { data } = await res.json();

        if (res.status == 200) {
          setPaymentHistory(data);
          // setRefresh(false);
        } else {
          throw new Error(data.message);
        }
        Notiflix.Loading.remove();
      } catch (error) {
        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    })();
  }, []);
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">
        <h5 style={{ color: PRIMARY_TEXT_COLOR }}>Payment History</h5>
      </div>
      <div className="mt-2" style={{ minHeight: "400px" }}>
        <CustomDataTable
          data={paymentHistory}
          columns={columnDefs}
          compact={true} // Enables compact styling
        />
      </div>
    </div>
  );
};

export default PaymentHistory;
